import { useEffect, useRef } from 'react';
// import { usePigMarker } from '../contexts/PigMarkerContext';

/**
 * When the browser tab becomes active, run a callback function - for example, updating the PIG position
 *  
 * @param {Function} callback - function that should be run when visibility changes
 * 
 * @returns {Function} useHandleVisibilityChange hook
 * 
 * @category Hooks
 */
function useHandleVisibilityChange(callback) {
    // const updatePigPosition = useContext(PigMarkerContext).updatePigPositionOnVisibilityChange;
    // const {updatePigPositionOnVisibilityChange} = usePigMarker();
    const updateCallbackRef = useRef(callback);

    useEffect(() => {
        updateCallbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                updateCallbackRef.current();
                console.log('Tab is active. Updated pig position.');
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [callback]);
}

export default useHandleVisibilityChange;
